import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Lock, LogIn } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await axios.post(`${API}/admin/login`, { password });
      localStorage.setItem("dj_admin_pwd", password);
      navigate("/admin");
    } catch (err) {
      setError("Mot de passe incorrect.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-black px-4">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(212,175,55,0.15),transparent_60%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,rgba(255,45,156,0.12),transparent_60%)]" />

      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="relative z-10 w-full max-w-md glass rounded-3xl p-8 md:p-10"
      >
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-[#D4AF37]/15 text-[#D4AF37] mb-6">
          <Lock size={24} />
        </div>
        <h1 className="text-2xl md:text-3xl font-bold text-white tracking-tight">
          Espace <span className="gold-text-gradient">administrateur</span>
        </h1>
        <p className="mt-2 text-sm text-zinc-400">
          Accès réservé à Adrien Sebert · DJ AS Animation
        </p>

        <label className="block mt-8 text-xs uppercase tracking-[0.22em] text-zinc-400 mb-2">
          Mot de passe
        </label>
        <input
          type="password"
          required
          autoFocus
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          data-testid="admin-login-password"
          placeholder="••••••••"
          className="w-full bg-white/[0.03] border border-white/10 rounded-xl px-4 py-3.5 text-white placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-[#D4AF37]/60 focus:border-[#D4AF37]/40"
        />

        {error && (
          <div data-testid="admin-login-error" className="mt-4 text-sm text-red-400">
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit"
          className="mt-7 w-full btn-gold rounded-full py-3.5 text-sm font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-60"
        >
          <LogIn size={16} /> {loading ? "Connexion..." : "Se connecter"}
        </button>

        <a
          href="/"
          className="mt-5 block text-center text-xs text-zinc-500 hover:text-zinc-300"
        >
          ← Retour au site
        </a>
      </form>
    </div>
  );
}
